(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["personnalys-pack-design-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('personnalys-pack-design')) {
    customElements.define('personnalys-pack-design', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        this.form = document.getElementById(this.dataset.formId);
        if (!this.form || this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.onSubmit = this.handleSubmit.bind(this);
        this.onChange = () => requestAnimationFrame(() => this.updateTotal());
        this.form.addEventListener('submit', this.onSubmit, true);
        this.form.addEventListener('change', this.onChange);
        this.addEventListener('change', this.onChange);
        this.updateTotal();
      }

      disconnectedCallback() {
        if (!this.form) return;
        this.form.removeEventListener('submit', this.onSubmit, true);
        this.form.removeEventListener('change', this.onChange);
      }

      selectedTables() {
        const root = this.closest('product-rerender') || document;
        const picker = root.querySelector('variant-picker[form-id="' + CSS.escape(this.dataset.formId) + '"]');
        const tableFieldset = Array.from(picker?.querySelectorAll('fieldset') || []).find((fieldset) => {
          const legend = fieldset.querySelector('legend');
          return legend && legend.textContent.trim().toLowerCase().startsWith('nombre de tables');
        });
        const checked = tableFieldset?.querySelector('input[type="radio"]:checked');
        const label = checked ? tableFieldset.querySelector('label[for="' + CSS.escape(checked.id) + '"]') : null;
        return Number.parseInt(label?.textContent || '', 10) || 9;
      }

      selectedDesign() {
        return this.querySelector('input[name="properties[Design et forme des numéros de table]"]:checked');
      }

      updateTotal() {
        const tables = this.selectedTables();
        const design = this.selectedDesign();
        const total = Number(design?.dataset.delta || 0) * tables;
        this.querySelector('[data-pack-design-tables]').textContent = String(tables);
        this.querySelector('[data-pack-design-total]').textContent = total === 0 ? 'Inclus' : `Supplément : +${total.toLocaleString('fr-FR')} €`;
      }

      async handleSubmit(event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const formData = new FormData(this.form);
        const variantId = Number(formData.get('id'));
        const packQuantity = Math.max(1, Number(formData.get('quantity') || 1));
        const tables = this.selectedTables();
        const design = this.selectedDesign();
        const properties = {};

        for (const [key, value] of formData.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && value !== '') properties[match[1]] = value;
        }

        const items = [{ id: variantId, quantity: packQuantity, properties }];
        const surchargeVariantId = Number(design?.dataset.surchargeVariant || 0);

        if (surchargeVariantId) {
          items.push({
            id: surchargeVariantId,
            quantity: tables * packQuantity,
            properties: {
              _Pack: this.dataset.packTitle,
              '_Variante du pack': String(variantId),
              '_Nombre de tables': String(tables),
              '_Design choisi': design.value
            }
          });
        }

        const submitButton = this.form.querySelector('[type="submit"]');
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.setAttribute('aria-busy', 'true');
        }

        const shopRoot = window.Shopify?.routes?.root || '/';
        try {
          const response = await fetch(`${shopRoot}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Ajout au panier impossible');
          window.location.assign(`${shopRoot}cart`);
        } catch (error) {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
          }
          window.alert('Une erreur est survenue lors de l’ajout du pack. Merci de réessayer.');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
